export const SESSION_STATUS = {
  NONE: "NONE",
  QUEUE: "QUEUE",
  CODE: "CODE",
  PLAY: "PLAY",
} as const;

export type fetchSessionStatusRequest = { query: { type: 1 | 2 } };
export type fetchSessionStatusResponse = {
  status: keyof typeof SESSION_STATUS;
  ttl: number; // seconds
};

export type clearSessionRequest = void;
export type clearSessionResponse = {success: boolean};
